import { render, staticRenderFns } from "./BaseControlError.vue?vue&type=template&id=4a6a5dff&"
import script from "./BaseControlError.vue?vue&type=script&lang=js&"
export * from "./BaseControlError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports